<script setup lang="ts">import { useUserStore as ___useUserStore } from "@client/stores"; const $$user =  ___useUserStore();import { $api } from "@client/lib/trpc";import { $socket } from "@client/lib/socket";
import { ArrowLeftIcon, XIcon, CheckIcon } from "lucide-vue-next";
import BaseSocial from "./Base.vue";

const activeComponent = defineModel<string>({ default: "List" });

$$user.requests = await $api.friends.requests.all.query();
const requests = $$user.requests;
const addedFriendUsername = ref("");

async function handleSendFriendRequest() {
	// if (!canSendFriendRequest.value) return;

	const addedUser = await $api.friends.add.mutate(addedFriendUsername.value);
	addedFriendUsername.value = "";
	if (!addedUser) return;
	requests.outgoing.push(addedUser);
	$socket.social.emit("friendRequestSent", { id: addedUser.id });
}
async function handleRemoveOutoingRequest(friendId: number) {
	await $api.friends.remove.mutate(friendId);
	requests.outgoing = requests.outgoing.filter((request) => request.id !== friendId);
}
async function handleAcceptFriendRequest(friendId: number) {
	await $api.friends.accept.mutate(friendId);
	requests.incoming = requests.incoming.filter((request) => request.id !== friendId);
	$$user.friendList = await $api.friends.list.query();
}
async function handleRejectFriendRequest(friendId: number) {
	await $api.friends.remove.mutate(friendId);
	requests.incoming = requests.incoming.filter((request) => request.id !== friendId);
	$$user.friendList = await $api.friends.list.query();
}

const canSendFriendRequest = computed(
	() =>
		!!addedFriendUsername.value && // Not empty
		addedFriendUsername.value !== $$user.user.username && // Can't add self
		!$$user.friendList.some((friend) => friend.username === addedFriendUsername.value) && // Not already friends
		!requests.outgoing.some((request) => request.username === addedFriendUsername.value) && // Not already sent request
		!requests.incoming.some((request) => request.username === addedFriendUsername.value), // Not already received request
);

function handleBackToFriendList() {
	activeComponent.value = "List";
}
</script>

<template>
	<BaseSocial>
		<template #prepend-title>
			<ArrowLeftIcon
				class="tw:self-center tw:justify-self-center tw:hover:scale-110 tw:cursor-pointer"
				@click="handleBackToFriendList" />

			<!-- <i-svg
				:src="backButtonUrl"
				width="24"
				height="24"
				class="tw:cursor-pointer tw:hover:scale-110 tw:self-center tw:justify-self-center"
				@click="handleBackToFriendList()"
				fill="#ECECEB" /> -->
		</template>
		<template #content>
			<main class="tw:bg-[--default-background-color] tw:pt-4 tw:px-2 tw:h-full">
				<div class="tw:h-full tw:flex tw:flex-col tw:px-5">
					<div class="tw:flex tw:flex-col tw:gap-4">
						<p class="tw:text-xs tw:truncate">ADD FRIEND REQUEST</p>
						<div
							class="tw:flex tw:gap-2 t tw:justify-center tw:items-center tw:flex-wrap">
							<v-text-field
								v-model="addedFriendUsername"
								density="compact"
								variant="solo"
								hide-details
								placeholder="Enter username"
								class="friend-name-textarea tw:!basis-3/5">
							</v-text-field>
							<button
								v-disabled-click="!canSendFriendRequest"
								@click="handleSendFriendRequest"
								class="tw:bg-(--accent-color) tw:text-[11px] tw:text-black tw:px-2 tw:py-[0.6rem] tw:basis-[10%]
									tw:flex-grow tw:hover:brightness-110 tw:hover:scale-110 tw:rounded-md">
								Send
							</button>
						</div>
					</div>
					<hr class="tw:my-6 tw:border-[#333333]" />
					<div class="tw:flex tw:flex-col tw:gap-4">
						<div class="tw:flex tw:w-full tw:text-xs">
							<span class="tw:truncate">INCOMING REQUESTS</span>
							<span>({{ requests.incoming.length }})</span>
						</div>
						<ul
							class="requests-list tw:flex tw:flex-col tw:gap-3 tw:overflow-y-auto tw:overflow-x-hidden">
							<li
								v-for="friend in requests.incoming"
								:key="friend?.id"
								class="tw:flex tw:gap-2 tw:items-center tw:justify-bet-en tw:max-xl:justify-center tw:p-2 tw:rounded-md
									tw:hover:bg-neutral-700 tw:flex-wrap tw:w-full">
								<div class="tw:flex tw:items-center tw:gap-1 tw:min-w-[60px]">
									<img
										class="tw:max-md:hidden tw:h-[max(20px,1.4vmax)] tw:rounded-full tw:object-cover tw:aspect-square"
										:src="friend?.avatarUrl!" />
									<p
										class="tw:truncate tw:text-[max(10px,0.6vmax)] tw:font-medium tw:text-center tw:w-full">
										{{ friend?.username }}
									</p>
								</div>
								<div
									class="tw:flex-wrap tw:flex tw:gap-2 tw:text-[10px] tw:justify-center tw:items-center">
									<v-btn
										title="Accept"
										@click="handleAcceptFriendRequest(friend.id)"
										size="15"
										variant="plain"
										class="tw:hover:scale-110">
										<CheckIcon :size="15" color="green" />
									</v-btn>

									<v-btn
										size="15"
										variant="plain"
										@click="handleRejectFriendRequest(friend.id)"
										title="Reject"
										class="tw:hover:scale-110">
										<XIcon :size="15" color="red" />
									</v-btn>
								</div>
							</li>
						</ul>
					</div>
					<hr class="tw:mb-6 tw:border-[#333333]" />
					<div class="tw:flex tw:flex-col tw:gap-4">
						<div class="tw:flex tw:w-full tw:text-xs">
							<span class="tw:truncate">OUTGOING REQUESTS</span>
							<span>({{ requests.outgoing.length }})</span>
						</div>
						<ul
							class="requests-list tw:flex tw:flex-col tw:gap-3 tw:overflow-y-auto tw:overflow-x-hidden">
							<li
								v-for="friend in requests.outgoing"
								:key="friend?.id"
								class="tw:flex tw:gap-2 tw:items-center tw:justify-bet-en tw:max-xl::justify-center tw:p-2 tw:rounded-md
									tw:hover:bg-neutral-700 tw:flex-wrap tw:w-full">
								<div class="tw:flex tw:items-center tw:gap-1 tw:min-w-[60px]">
									<img
										class="tw:max-md:hidden tw:h-[max(20px,1.4vmax)] tw:rounded-full tw:object-cover tw:aspect-square"
										:src="friend?.avatarUrl!" />
									<p
										class="tw:truncate tw:text-[max(10px,0.6vmax)] tw:font-medium tw:text-center tw:w-full">
										{{ friend?.username }}
									</p>
								</div>
								<div
									class="tw:flex-wrap tw:flex tw:gap-2 tw:text-[10px] tw:justify-center tw:items-center">
									<v-btn
										@click="handleRemoveOutoingRequest(friend.id)"
										size="15"
										title="Cancel"
										class="tw:hover:scale-110"
										variant="plain">
										<XIcon :size="15" color="red" />
									</v-btn>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</main>
		</template>
	</BaseSocial>
</template>
<style scoped lang="scss">
:deep(.friend-name-textarea) {
	& input.v-field__input {
		font-size: 11px;
	}
}
.requests-list {
	scrollbar-width: thin;
}
</style>
